import React, { createContext } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AppStore from './store/AppStore';

export const Context = createContext(null)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Context.Provider value={{
        app: new AppStore(),
    }}>
        <App />
    </Context.Provider>
);

